import React, { useEffect, useContext, useRef } from "react";
import Cookies from "js-cookie";
import Head from "next/head";
import Router from "next/router";
import PropTypes from "prop-types";
import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../constants/theme";
import { ContextState } from "context";
import MainLayout from "layouts/MainLayout";
import "../styles/globals.css";
import "../styles/tailwind.css";
import "../utils/fontawesome";
import i18n from "i18next";
import { useRouter } from "next/router";
import "i18n";
import { appWithTranslation } from "react-i18next";
import { CHANGE_LANG, setUser, logout } from "context/actions/auth";
import { GlobalContext } from "context";

import ProgressBar from "@badrap/bar-of-progress";

const progress = new ProgressBar({
  size: 3,
  color: "#373A46",
  className: "bar-of-progress",
  delay: 100,
});

Router.events.on("routeChangeStart", progress.start);
Router.events.on("routeChangeComplete", progress.finish);
Router.events.on("routeChangeError", progress.finish);


function AppInitializer() {
    const { state, dispatch } = useContext(GlobalContext);
    // const auth = state?.auth;

    // const { data: session } = useSession();

    useEffect(() => {
        setAllUser();
    }, [dispatch]);

    const setAllUser = async () => {
        // const res1 = await setAccount(dispatch, {
        //     id: auth?.account?.accountId,
        //     session,
        // });
        // if (res1.status !== 'success') {
        //     await logoutAccount(dispatch);
        // }
        const res2 = await setUser(dispatch);
        if (res2.status !== 'success') {
            await logout(dispatch);
        }
    };

    return null;
}
function MyApp(props) {
    const positionsRef = useRef({}); // 👈 render хооронд хадгалагдана
    const shouldRestoreRef = useRef(false);

  const { Component, pageProps } = props;

  const Layout = Component.Layout || MainLayout;
    const router = useRouter();

  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }

    if (typeof window !== "undefined") {
      const chosenLang = Cookies.get("chosen_lang");

      i18n.changeLanguage(chosenLang ? chosenLang : "mn");
    }
  }, []);


    useEffect(() => {
        if (!('scrollRestoration' in window.history)) return;

        window.history.scrollRestoration = 'manual';

        const saveScroll = (url) => {
            positionsRef.current[url] = window.scrollY;
        };

        const restoreScroll = (url) => {
            const y = positionsRef.current[url] || 0;
            window.scrollTo(0, y);
        };

        const onRouteChangeStart = (url) => {
            saveScroll(router.asPath);
        };

        const onRouteChangeComplete = (url) => {
            if (shouldRestoreRef.current) {
                shouldRestoreRef.current = false;
                setTimeout(()=> {
                restoreScroll(url);}, 200)
            } else {
                window.scrollTo(0, 0);
            }
        };

        const onPopState = () => {
            shouldRestoreRef.current = true;
        };

        window.addEventListener('popstate', onPopState);
        router.events.on('routeChangeStart', onRouteChangeStart);
        router.events.on('routeChangeComplete', onRouteChangeComplete);

        return () => {
            window.removeEventListener('popstate', onPopState);
            router.events.off('routeChangeStart', onRouteChangeStart);
            router.events.off('routeChangeComplete', onRouteChangeComplete);
        };
    }, [router]);

  return (
    <React.Fragment>
      <Head>


        <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
        />
        <title>Баянгол тохижилт үйлчилгээ ОНӨААТҮГазар</title>

        <meta
            name="description"
            content="Баянгол тохижилт үйлчилгээ ОНӨААТҮГазар"
        />

        <link rel="shortcut icon" href="/Logo.png" />
        <meta charSet="utf-8" />
        <meta property="og:title" content="Баянгол тохижилт үйлчилгээ ОНӨААТҮГазар" key="title" />
        <meta property="og:image" content="/logo.png" key="ogimage" />

        <meta
            property="og:description"
            content="Баянгол тохижилт үйлчилгээ ОНӨААТҮГазар"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/Logo.png" />
      </Head>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ContextState>

          <AppInitializer />
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </ContextState>
      </ThemeProvider>
    </React.Fragment>
  );
}

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
};

export default MyApp;
